import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=0a9eb85c&scoped=true"
import script from "./ArticlesList.vue?vue&type=script&lang=js"
export * from "./ArticlesList.vue?vue&type=script&lang=js"
import style0 from "./ArticlesList.vue?vue&type=style&index=0&id=0a9eb85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9eb85c",
  null
  
)

export default component.exports